import React from 'react';
import {
  List,
  Filter,
  Datagrid,
  BooleanField,
  EditButton,
  TextInput,
  TextField,
  NumberField,
} from "react-admin";
import * as XLSX from "xlsx";

const SellerTitle = () => {
  return <span>Puntos de Venta</span>;
};

const SellerFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Buscar nombre" source="name" alwaysOn />
    <TextInput label="Sitio Web" source="webSite" />
  </Filter>
);

// Función personalizada de exportación
const sellersExporter = (data) => {
  const exportData = data.map((record) => ({
    ID: record.id,
    Posición: record.position || "-",
    Nombre: record.name,
    "Sitio Web": record.webSite || "-",
    Activo: record.active ? "Sí" : "No",
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(exportData);

  const colWidths = Object.keys(exportData[0]).map((h) => ({
    wch: Math.max(h.length, 15),
  }));
  ws["!cols"] = colWidths;

  XLSX.utils.book_append_sheet(wb, ws, "Puntos de Venta");
  XLSX.writeFile(
    wb,
    `puntos-de-venta-${new Date().toISOString().split("T")[0]}.xlsx`
  );
};

export const ListSeller = (props) => (
  <List
    filters={<SellerFilter />}
    title={<SellerTitle />}
    {...props}
    sort={{ field: "createdAt", order: "ASC" }}
    exporter={sellersExporter}
  >
    <Datagrid>
      <NumberField source="id" label="ID" />
      <NumberField source="position" label="Posición" />
      <TextField source="name" label="Nombre" />
      <TextField source="webSite" label="Sitio Web" />
      <BooleanField source="active" label="Activo" />
      <EditButton />
    </Datagrid>
  </List>
);